import { render } from "./SalesByGenderChart.vue?vue&type=template&id=01bc58be&scoped=true&ts=true"
import script from "./SalesByGenderChart.vue?vue&type=script&lang=ts"
export * from "./SalesByGenderChart.vue?vue&type=script&lang=ts"

import "./SalesByGenderChart.vue?vue&type=style&index=0&id=01bc58be&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01bc58be"]])

export default __exports__